import { Injectable } from '@angular/core';
import { Observable, throwError, of, Subject, BehaviorSubject, fromEvent } from 'rxjs';
import { retry, catchError, map, finalize, tap, filter, debounceTime, distinctUntilChanged, mergeMap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocationModel } from "src/app/location/location";
import { AuthService } from "src/app/auth.service";
import { environment } from '../../../environments/environment';
import { MessagerComponent } from '../../messager/messager/messager.component';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {

  private baseURL = environment.baseUrl;

  constructor(private http: HttpClient, private messager: MessagerComponent){}


  sendContactEmail(content): Observable<any>{
    return this.http.post(this.baseURL + '/rhAPI/emails/sendHVACEmail', content, {observe:'body'});
  }


}
